// eslint-disable-next-line max-classes-per-file
import React from 'react';
import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';

type NamePath<K> = K | [K, ...string[]];

// @ts-ignore
interface Props<T extends { [name: string]: any }, K extends string> extends FormItemProps {
    name?: NamePath<K>;
    dependencies?: NamePath<K>[];
    shouldUpdate?: true | ((prevValues: T, newValues: T) => boolean);
}

// Use class component because of generic support
// eslint-disable-next-line react/prefer-stateless-function
class FormItem<T extends { [key: string]: any }, K extends string = keyof T & string> extends React.Component<
    Props<T, K>
> {
    render() {
        // @ts-ignore
        return <Form.Item {...this.props}>{this.props.children}</Form.Item>;
    }
}

interface ConsumerInternalProps<V> {
    value: V;
    onChange: (value?: V) => void;
}

interface FormItemWrapperProps<V>
    extends Partial<ConsumerInternalProps<V>>,
        React.ConsumerProps<ConsumerInternalProps<V>> {}

// Use class component because of generic support for generic props
// A wrapper class to trigger form update in parent level
export class FormItemWrapper<V> extends React.Component<FormItemWrapperProps<V>, {}> {
    triggerChange = (value: V) => {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
        const { children } = this.props as any;
        return children({ onChange: this.triggerChange, value: this.props.value });
    }
}

export default FormItem;
